import { useQueryClient } from "@tanstack/react-query";

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  const invalidateQuery = (queryKey: string[]): void => {
    queryClient
      .invalidateQueries({ queryKey })
      .then(() => console.log(`${queryKey.join(", ")} query invalidated.`))
      .catch((error) => {
        console.error(
          `Error invalidating ${queryKey.join(", ")} query:`,
          error,
        );
      });
  };

  return {
    invalidateProjects: () => invalidateQuery(["projects"]),
    invalidateShips: () => invalidateQuery(["ships"]),
    invalidateStudies: () => invalidateQuery(["studies"]),

    invalidateStudy: (id: string) => invalidateQuery(["study", id]),
    invalidateShip: (id: string) => invalidateQuery(["ship", id]),
    invalidateProject: (id: string) => invalidateQuery(["project", id]),
  };
};
